export default [
  {
    title: 'breadcrumb.cockBalanceReport',
    route: 'cock-balance-report',
    icon: '',
    resource: 'balance-report',
    action: 'read'
  }
];